import Icon from "../../assets/icons";
import logoutConfirmationDailouge from "../../services/Logout";
import store, { RootState } from "../../store";
import { Box, Popover } from "@radix-ui/themes";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { HiOutlineClipboardCheck } from "react-icons/hi";
import { useSelector } from "react-redux";
import VERSION from "../../config/version";
import calculateFilledPercentage from "../../utils/calculateFilledPercentage";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import ProfileProgressBar from "./ProfileProgressBar";
import { IconType } from "react-icons";

interface MenuItem {
  name: string;
  href: string;
  description?: string;
  icon: IconType;
  arrow: any;
}

interface Props {
  menus: MenuItem[];
  onClose?: () => void; // callback to close the Dialog
}

const ProfileMenu: React.FC<Props> = ({ menus, onClose }) => {
  const router = useNavigate();
  const { user, profilePhoto, profilePercentage } = useSelector((state: RootState) => state.auth);
  const profileData: any = useSelector((state: RootState) => state.auth.profileData);


  const extraMenus = [
    {
      name: 'Terms of Service',
      description: 'Terms of Service',
      href: '/terms-services',
      icon: HiOutlineClipboardCheck,
      arrow: <MdOutlineArrowForwardIos />,
    },
  ];

  const handleNavigation = (href: string) => {
    router(href);
    onClose?.();
  };

  const handleLogout = () => {
    onClose?.();
    logoutConfirmationDailouge(() => {
      router('/login');
      store.dispatch({ type: "RESET_APP" });
      document.cookie = `${'access-token'}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.viliyo.com; SameSite=None; Secure`;
    });
  };

  return (
    <Box className="bg-white h-full">
      {/* Profile Header */}
      <div className="flex m-2 w-42 h-30 space-x-6 px-4">
        {user && (
          <>
            <div className="mx-0">
              <ProfileProgressBar
                avatarUrl={profilePhoto ?? user.profilePhoto ?? ''} // Fallback to empty string
                profileCompletion={profilePercentage}
              />
            </div>
            <div>
              <h1 className="text-xl font-bold text-zinc-600">{profileData?.name}</h1>
              <p className="text-app-blue font-medium text-sm">
                Your profile is {profilePercentage}% complete
              </p>
            </div>
          </>
        )}
      </div>

      {/* Rest of the component remains unchanged */}
      <div className="mb-2">
        <hr className="bg-app-gray h-[0.5px]" />
      </div>

      {/* Main Menus */}
      <ul className="space-y-2 px-4">
        {menus.map((menu) => (
          <li key={menu.name}>
            <button
              onClick={() => handleNavigation(menu.href)}
              className="flex w-full cursor-pointer hover:scale-105 hover:bg-app-purple p-1.5 rounded-lg items-center justify-between text-right"
            >
              <span className="w-8 h-8 bg-purple-200 rounded p-2">
                <menu.icon className="w-4 h-4" />
              </span>
              <div className="w-40 ml-5 text-left">
                <span className="text-gray-900">{menu.name}</span>
              </div>
              <MdOutlineArrowForwardIos />
            </button>
          </li>
        ))}
      </ul>

      <div className="mb-2">
        <hr className="bg-app-gray h-[0.5px]" />
      </div>

      {/* Extra Menus */}
      <ul className="space-y-2 px-4">
        {extraMenus.map((menu) => (
          <li key={menu.name}>
            <button
              onClick={() => handleNavigation(menu.href)}
              className="flex w-full cursor-pointer hover:scale-105 hover:bg-purple-100 p-1.5 rounded-lg items-center justify-between text-right"
            >
              <span className="w-8 h-8 bg-purple-200 rounded p-2">
                <menu.icon className="w-4 h-4" />
              </span>
              <div className="w-40 ml-5 text-left">{menu.name}</div>
              <MdOutlineArrowForwardIos />
            </button>
          </li>
        ))}

        {/* About */}
        <li>
          <button
            onClick={() => handleNavigation('/about')}
            className="flex w-full cursor-pointer hover:scale-105 hover:bg-app-purple p-1.5 rounded-lg items-center justify-between text-right"
          >
            <span className="w-8 h-8 bg-purple-200 rounded flex items-center justify-center text-[10px] font-semibold text-gray-700">
              VTT
            </span>

            <div className="w-40 ml-5 text-left">
              About 
              {/* ( {VERSION} ) */}
            </div>

            <MdOutlineArrowForwardIos />
          </button>
        </li>
      </ul>

      <div className="my-2">
        <hr className="bg-app-gray h-[0.5px]" />
      </div>

      {/* Logout */}
      <ul className="px-2">
        <li>
          <button
            onClick={handleLogout}
            className="font-bold text-app-blue px-4 text-base w-full text-left"
          >
            Log out
          </button>
        </li>
      </ul>
    </Box>
  );
};
export default ProfileMenu